import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { Text } from "@domestika-dev/prudencio/dist/atoms/Typography/Typography";
import { GridItem } from "@domestika-dev/prudencio/dist/atoms/Layout";

export const LiveSetupTitle = ({ title }) => (
  <GridItem gridColumn="1 / span 6" gridRow="2" marginTop={4}>
    <Text size="medium" fontWeight="medium" as="h1" textAlign="left">
      <FormattedMessage id={title} />
    </Text>
  </GridItem>
);

LiveSetupTitle.propTypes = {
  title: PropTypes.string.isRequired,
};

export default LiveSetupTitle;
